"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HelpOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M7.515 24.485a12 12 0 1 1 16.97 0 12.013 12.013 0 0 1-16.97 0M6.1 25.9a14 14 0 1 0 0-19.8 14 14 0 0 0 0 19.8z"></path><path d="M15.969 8.75c-2.006 0-3.574.8-4.185 2.119a2.482 2.482 0 0 0-.284 1.158.973.973 0 0 0 1.055 1.064 1.093 1.093 0 0 0 1.107-.83 2.144 2.144 0 0 1 2.167-1.57 1.952 1.952 0 0 1 2.09 1.986c0 1.05-.437 1.659-1.792 2.506a2.868 2.868 0 0 0-1.684 2.569v.148a1.092 1.092 0 0 0 1.126 1.222c.352 0 .841-.091 1.032-.937.138-.893.429-1.406 1.875-2.285a3.645 3.645 0 0 0 2.024-3.318c0-2.292-1.821-3.832-4.531-3.832z"></path><path d="M15.574 20.547A1.355 1.355 0 1 0 16.83 21.9a1.3 1.3 0 0 0-1.256-1.353z"></path>';
var HelpOutlineSVG = function HelpOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HelpOutlineSVG = HelpOutlineSVG;
HelpOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HelpOutlineSVG);
exports.default = _default;